import IndividualPlaylist from './IndividualPlaylist';

export default function PlaylistRoute() {
    return <IndividualPlaylist />;
}
